import {
  Item
} from '@app/shared/interfaces/common-interfaces';

export class SigningModel {
  signFile: string;
  signFormat: string;
  signLevel: string;
  signType: string;
  signHashAlg: string;
}

export interface ISigningValuesDefaultsInterface {
  signFormat: string;
  signLevel: string;
  signType: string;
  signHashAlg: string;
}

export interface ISigningValuesInterface {
  signFile: string;
  signFormat: Item[];
  signLevel: Item[];
  signType: Item[];
  signHashAlg: Item[];
  defaults: ISigningValuesDefaultsInterface;
}

export interface InfoTextsInterface {
  cades: string;
  pades: string;
  xades: string;
  asice: string;
  asics: string;
  leveInfo: string;
  typeInfo: string;
  hashInfo: string;
  note: string;
  fileSizeExceeded: string;
  chooseFile: string;
  fileName: string;
  fileSize: string;
  sign: string;
  confirmSigning: string;
  signError: string;
  docEmptyError: string;
  signSuccess: string;
  advanced: string;
}

export interface ISigningTextsInterface {
  chooseFile: string;
  signing: string;
  signResult: string;
  signFile: string;
  signFormat: string;
  signLevel: string;
  signType: string;
  signHashAlg: string;
  info: InfoTextsInterface;
  button: string;
}

export class SigningTexts implements ISigningTextsInterface {
  chooseFile;
  signing;
  signResult;
  signFile;
  signFormat;
  signLevel;
  signType;
  signHashAlg;
  info = {} as InfoTextsInterface;
  button;
}
